/**
 * GX Feel Good — mobile horizontal slider + pagination dots
 */
(function () {
  var MOBILE_QUERY = window.matchMedia('(max-width: 767px)');

  function initFeelGood(root) {
    if (!root || root.dataset.gxFeelInit === '1') return;
    root.dataset.gxFeelInit = '1';

    var track = root.querySelector('[data-gx-feel-track]');
    var dotsWrap = root.querySelector('[data-gx-feel-dots]');
    if (!track) return;

    var slides = track.querySelectorAll('[data-gx-feel-slide]');
    var dots = dotsWrap ? dotsWrap.querySelectorAll('[data-gx-feel-dot]') : [];

    function isMobileSlider() {
      return MOBILE_QUERY.matches;
    }

    function getActiveIndex() {
      if (!slides.length) return 0;
      if (!isMobileSlider()) return 0;

      var trackRect = track.getBoundingClientRect();
      var trackCenter = trackRect.left + trackRect.width / 2;
      var closest = 0;
      var closestDist = Infinity;

      slides.forEach(function (slide, i) {
        var rect = slide.getBoundingClientRect();
        var center = rect.left + rect.width / 2;
        var dist = Math.abs(center - trackCenter);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });

      return closest;
    }

    function setActive(index) {
      slides.forEach(function (slide, i) {
        if (isMobileSlider()) {
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        } else {
          slide.setAttribute('aria-hidden', 'false');
        }
      });

      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
        dot.setAttribute('tabindex', active ? '0' : '-1');
      });
    }

    function scrollToIndex(index) {
      if (!isMobileSlider()) return;
      var slide = slides[index];
      if (!slide) return;
      var offset = slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;
      track.scrollTo({ left: offset, behavior: 'smooth' });
      setActive(index);
    }

    function onScroll() {
      if (!isMobileSlider()) return;
      setActive(getActiveIndex());
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { scrollToIndex(i); });
    });

    track.addEventListener('scroll', onScroll, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (!isMobileSlider()) return;
      var idx = getActiveIndex();
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        scrollToIndex(Math.min(idx + 1, slides.length - 1));
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        scrollToIndex(Math.max(idx - 1, 0));
      }
    });

    MOBILE_QUERY.addEventListener('change', function () {
      if (isMobileSlider()) {
        setActive(getActiveIndex());
      } else {
        slides.forEach(function (slide) {
          slide.setAttribute('aria-hidden', 'false');
        });
      }
    });

    setActive(0);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-gx-feel-root]').forEach(initFeelGood);
  }

  document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:reorder', function (e) { boot(e.target); });
})();
